// extracted by css-extract-rspack-plugin
export default {"AnalyticChart":"AnalyticChart-SW5Oz_","analyticChart":"AnalyticChart-SW5Oz_","ChartContainer":"ChartContainer-QIcqGX","chartContainer":"ChartContainer-QIcqGX"};